// #region Imports
import { defineComponent } from "vue";
import { appWindow } from "../classes/Windows";
// #endregion
// #region Core
export default defineComponent({
    // #region  Vars
    name: 'g-app',
    // #endregion
    // #region Data
    data: () => ({
        layout: '',
    }),
    // #endregion
    // #region Show
    created() {
        // #region Window
        this.appWindow = new appWindow(this.$appHost, this);
        // #endregion
        // #region Host
        this.$appHost.setMainWindow(this.appWindow);
        // #endregion                       
    },
    // #endregion
    // #region Computed
    computed: {
        _layout() {
            if (!utils.isNullOrEmpty(this._meta?.layout)) {
                return this._meta.layout;
            }
            else {
                return this.$appHost.config.layoutName;
            }
        },
        _widthMode() {
            if (!utils.isNullOrEmpty(this._meta?.widthMode)) {
                return this._meta.widthMode;
            }
            else {
                return 'default';
            }
        },
        _meta() {
            return this.$route?.meta ?? {};
        }
    },
    // #endregion
});
// #endregion
